// TEMPORARY: mock data used by the dev toggle on the Funding Requests page so we
// can preview the populated table before the real API exists. Remove alongside
// the toggle once funding requests are wired to a data source.

export const FUNDING_REQUEST_STATUSES = ['pending', 'approved', 'rejected'];

// Interleaved by status (pending, approved, rejected, ...) so that filtering by a
// single status yields 5 records and the "all" tab shows a mixed set of 5.
const MOCK_FUNDING_REQUESTS = [
  {
    id: 'FR-1042',
    account: 'Groupe Verdier SAS',
    requester: 'Élodie Verdier',
    date: '16/06/2026',
    amount: '£500.00',
    proofOfPayment: 'remittance-16-06.pdf',
    transferReference: 'GROUPE-VERDIER-8842',
    status: 'pending',
  },
  {
    id: 'FR-1041',
    account: 'Translog Nord SARL',
    requester: 'Marc Dubois',
    date: '15/06/2026',
    amount: '£1,200.00',
    proofOfPayment: 'virement-sepa-1200.pdf',
    transferReference: 'TRANSLOG-NORD-1200',
    status: 'approved',
  },
  {
    id: 'FR-1039',
    account: 'Médica Sud SA',
    requester: 'Claire Fontaine',
    date: '14/06/2026',
    amount: '£250.00',
    proofOfPayment: 'proof-of-transfer.pdf',
    transferReference: 'MEDICA-SUD-0250',
    status: 'rejected',
  },
  {
    id: 'FR-1036',
    account: 'Groupe Verdier SAS',
    requester: 'Marc Dubois',
    date: '12/06/2026',
    amount: '£300.00',
    proofOfPayment: 'remittance-12-06.pdf',
    transferReference: 'GROUPE-VERDIER-0300',
    status: 'pending',
  },
  {
    id: 'FR-1034',
    account: 'Nordic Freight AB',
    requester: 'Astrid Lindqvist',
    date: '11/06/2026',
    amount: '£2,100.00',
    proofOfPayment: 'bank-transfer-2100.pdf',
    transferReference: 'NORDIC-FREIGHT-2100',
    status: 'approved',
  },
  {
    id: 'FR-1031',
    account: 'Iberia Logística SL',
    requester: 'Diego Fernández',
    date: '10/06/2026',
    amount: '£4,750.00',
    proofOfPayment: 'comprobante-4750.pdf',
    transferReference: 'IBERIA-LOGISTICA-4750',
    status: 'rejected',
  },
  {
    id: 'FR-1029',
    account: 'Alpine Transit GmbH',
    requester: 'Lena Fischer',
    date: '09/06/2026',
    amount: '£1,020.00',
    proofOfPayment: 'ueberweisung-1020.pdf',
    transferReference: 'ALPINE-TRANSIT-1020',
    status: 'pending',
  },
  {
    id: 'FR-1027',
    account: 'Meridian Couriers Ltd',
    requester: 'Tom Richards',
    date: '08/06/2026',
    amount: '£320.75',
    proofOfPayment: 'remittance-320.pdf',
    transferReference: 'MERIDIAN-COURIERS-0320',
    status: 'approved',
  },
  {
    id: 'FR-1025',
    account: 'Adriatic Haulage doo',
    requester: 'Elena Rossi',
    date: '07/06/2026',
    amount: '£6,200.00',
    proofOfPayment: 'proof-6200.pdf',
    transferReference: 'ADRIATIC-HAULAGE-6200',
    status: 'rejected',
  },
  {
    id: 'FR-1022',
    account: 'Groupe Verdier SAS',
    requester: 'Nathan Cole',
    date: '06/06/2026',
    amount: '£1,880.00',
    proofOfPayment: 'remittance-1880.pdf',
    transferReference: 'GROUPE-VERDIER-1880',
    status: 'pending',
  },
  {
    id: 'FR-1020',
    account: 'Baltic Cargo UAB',
    requester: 'Grace Liu',
    date: '05/06/2026',
    amount: '£990.00',
    proofOfPayment: 'transfer-990.pdf',
    transferReference: 'BALTIC-CARGO-0990',
    status: 'approved',
  },
  {
    id: 'FR-1018',
    account: 'Translog Nord SARL',
    requester: 'Omar Haddad',
    date: '04/06/2026',
    amount: '£2,640.00',
    proofOfPayment: 'virement-2640.pdf',
    transferReference: 'TRANSLOG-NORD-2640',
    status: 'rejected',
  },
  {
    id: 'FR-1015',
    account: 'Médica Sud SA',
    requester: 'Hannah Schmidt',
    date: '03/06/2026',
    amount: '£450.00',
    proofOfPayment: 'proof-450.pdf',
    transferReference: 'MEDICA-SUD-0450',
    status: 'pending',
  },
  {
    id: 'FR-1013',
    account: 'Helvetia Transport AG',
    requester: 'Liam Murphy',
    date: '02/06/2026',
    amount: '£3,150.00',
    proofOfPayment: 'ueberweisung-3150.pdf',
    transferReference: 'HELVETIA-TRANSPORT-3150',
    status: 'approved',
  },
  {
    id: 'FR-1011',
    account: 'Nordic Freight AB',
    requester: 'Yuki Tanaka',
    date: '01/06/2026',
    amount: '£780.25',
    proofOfPayment: 'bank-transfer-780.pdf',
    transferReference: 'NORDIC-FREIGHT-0780',
    status: 'rejected',
  },
];

// Returns 5 mock records for the given tab. Status tabs return 5 records of that
// status; the "all" tab returns a mixed set of 5.
export const getFundingRequestsMockData = tabKey => {
  if (tabKey === 'all') {
    return MOCK_FUNDING_REQUESTS.slice(0, 5);
  }
  return MOCK_FUNDING_REQUESTS.filter(record => record.status === tabKey).slice(0, 5);
};

// Whether the Actions column (and its Review button) is shown for a given tab.
// Matches the mockup: actions appear on the Pending and All tabs only.
export const tabShowsActions = tabKey => tabKey === 'pending' || tabKey === 'all';

export default MOCK_FUNDING_REQUESTS;
